import { ENTRY_DATA_SECTION_KEYS as SECTION_KEYS } from "@frontend/common";

import {
  DealLaScDealTermsRightsFlowShellKeys,
  DealLaScDealTermsRightsScopeTableShellKeys,
} from "@/types/dealLaSc.types";

import type { ArticleEntryData } from "@/types/articleEntryData.types";

const RIGHTS_SCOPE_MULTI_SELECT_SHELL_KEYS: DealLaScDealTermsRightsScopeTableShellKeys[] =
  ["Rights Scope"];

const RIGHTS_FLOW_MULTI_SELECT_SHELL_KEYS: DealLaScDealTermsRightsFlowShellKeys[] =
  ["Benefiting Axis", "Contributing Axis"];

/**
 * Multi-select 값 전체를 교체하는 entryData 업데이트 함수 모음.
 * Rights Scope Table 안의 "Rights Scope", "Benefiting Axis", "Contributing Axis"를 지원한다.
 */
export const MULTI_SELECT_PATH_TO_SET_VALUES: Record<
  string,
  Record<
    string,
    (
      data: ArticleEntryData,
      subGroupShellIndex: number,
      shellKey: string,
      values: string[],
    ) => ArticleEntryData
  >
> = {
  [SECTION_KEYS.dealsLaSc]: {
    "Rights Scope Table": (
      data: ArticleEntryData,
      subGroupShellIndex: number,
      shellKey: string,
      values: string[],
    ): ArticleEntryData => {
      const newValues = values.map((v) => ({ text: v, is_modified: true }));

      if (
        RIGHTS_SCOPE_MULTI_SELECT_SHELL_KEYS.includes(
          shellKey as DealLaScDealTermsRightsScopeTableShellKeys,
        )
      ) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Rights Scope Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Rights Scope Table"
            ]?.map((tableItem, tableItemIndex) => {
              if (tableItemIndex !== subGroupShellIndex) return tableItem;
              return {
                ...tableItem,
                [shellKey as DealLaScDealTermsRightsScopeTableShellKeys]: {
                  ...tableItem?.[
                    shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                  ],
                  value: newValues,
                },
              };
            }),
          },
        };
      }

      if (
        RIGHTS_FLOW_MULTI_SELECT_SHELL_KEYS.includes(
          shellKey as DealLaScDealTermsRightsFlowShellKeys,
        )
      ) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Rights Scope Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Rights Scope Table"
            ]?.map((tableItem, tableItemIndex) => {
              if (tableItemIndex !== subGroupShellIndex) return tableItem;
              return {
                ...tableItem,
                "Rights Flow": {
                  ...tableItem?.["Rights Flow"],
                  [shellKey as DealLaScDealTermsRightsFlowShellKeys]: {
                    ...tableItem?.["Rights Flow"]?.[
                      shellKey as DealLaScDealTermsRightsFlowShellKeys
                    ],
                    value: newValues,
                  },
                },
              };
            }),
          },
        };
      }

      return data;
    },
  },
};
